import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

const MODIFY_PLANOGRAM_ITEM_PRODUCT = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default MODIFY_PLANOGRAM_ITEM_PRODUCT;


